import React from 'react';

// Components
import WpLabel from '../label/WpLabel';
import WpInlineError from '../inline-error/WpInlineError';
import WpHelpText from '../help-text/WpHelpText';

// Styles
import './WpLabelled.scss';

export interface Props {
  /** A unique identifier for the label */
  id: string;
  /** Text for the label */
  label: string;
  /** Error to display beneath the label */
  error?: string;
  /** Additional hint text to display */
  helpText?: string | React.ReactNode;
  /** Content to display inside the connected */
  children?: React.ReactNode;
  /** Visually hide the label */
  labelHidden?: boolean;
  /** show required indicator */
  showRequiredIndicator?: boolean;
  labelIcon?: string;
  labelTooltipText?: string;
}

const WpLabelled = ({
  id,
  label,
  helpText,
  error,
  children,
  labelHidden,
  labelIcon,
  labelTooltipText,
  showRequiredIndicator = true,
  ...rest
}: Props) => {
  const helpTextMarkup = helpText ? <WpHelpText message={helpText} /> : null;

  const errorMarkup = error && <WpInlineError error={error} id={id} />;

  const labelMarkup = label ? (
    <WpLabel
      id={id}
      {...rest}
      hidden={labelHidden}
      showRequiredIndicator={showRequiredIndicator}
      labelIcon={labelIcon}
      labelTooltipText={labelTooltipText}
    >
      {label}
    </WpLabel>
  ) : null;

  return (
    <div className="WpLabelled">
      {labelMarkup}
      {children}
      {errorMarkup}
      {helpTextMarkup}
    </div>
  );
};

export default WpLabelled;
